export default __webpack_public_path__ + "static/media/launch-home@2x.2ac07a63.png";